import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConstants } from "src/app/app.constants";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: "root",
})
export class ClinicalInfoService {
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getFourthSection(ndaValue, brand_name): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("brand_name", brand_name);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SECTION_API.CLINICAL_INFORMATION}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  SendEmail(
    active_ingredient,
    brand_name,
    ndaValue,
    email,
    data
  ): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    paramsInput = paramsInput.append("email", email);
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SENDEMAIL.CLINICAL_INFO}`,
      { data },
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getEditedData(
    active_ingredient,
    brand_name,
    ndaValue,
    userIp,
    uniqnumber,
    email
  ): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("userip", userIp);
    paramsInput = paramsInput.append("uniqnumber", uniqnumber);
    paramsInput = paramsInput.append("email", email);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.GETEDITEDDATA.CLINICAL_INFO}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateMoleculeData(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.UPDATEMOLECULEDATA.CLINICAL_UPDATED_DATA}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getScreenshotsAPI(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.GET_LCM_SCREENSHOTS}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  toggleEvidenceAPI(data: any): Observable<any> {
    return this.http.post(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SECTION_API.TOGGLE_LCM_EVIDENCE}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
